/**
 * External dependencies
 */
import { AxiosInstance, AxiosResponse } from 'axios';

/**
 * Internal dependencies
 */
import Header from '@naruto/naruto-api/src/tools/Header';
import BaseAPI from '@naruto/naruto-api/src/base';
import { BaseResponse } from './types';

class AttachmentAPI extends BaseAPI {
  constructor({ axios, header }: { axios: AxiosInstance; header: Header }) {
    super({ axios, header });
  }

  /* ======== API: attachment ======== */
  async postAttachment<Response, Body = undefined>(body?: Body): Promise<BaseResponse<Response>> {
    try {
      const res = await this.axios.post<Body, AxiosResponse<Response>>('/api/admin/attachments', body, {
        headers: { ...this.header.header }
      });
      return { response: res.data, status: res.status, headers: res.headers };
    } catch (error) {
      const responseData = this.generatorAPIError(error) as BaseResponse<Response>;
      return responseData;
    }
  }
}

export default AttachmentAPI;
